import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getIsco4AIChartData = async (ISCO4Codes: string[]) => {
    const { path, method } = endpoints.occupationAndSector.getIsco4AIChartData;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { ISCO4Codes },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
